class GedcomModalManager {
  extractFamilyNameFromFilename = (filename) => {
    let match = filename.match(/_fam_(.+?)_date_\d{4}-\d{2}-\d{2}_processed\.(?:json|lz)$/);
    if (match) {
      const familyName = match[1];
      return familyName.charAt(0).toUpperCase() + familyName.slice(1);
    }

    match = filename.match(/_fam_(.+?)(?:_processed\.(?:json|lz)|\.ged)$/);
    if (match) {
      const familyName = match[1];
      return familyName.charAt(0).toUpperCase() + familyName.slice(1);
    }

    const cleanName = filename
      .replace(/_processed\.(json|lz)$/, '')
      .replace(/\.(ged|gedcom|json|lz)$/i, '');

    const parts = cleanName.split('_');
    const displayName = parts[parts.length - 1] || cleanName;

    return displayName.charAt(0).toUpperCase() + displayName.slice(1);
  };
}

const gedcomModalManager = new GedcomModalManager();
export default gedcomModalManager;
